import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inventory: [],
  loading: false,
  error: null,
};

const getInventorySlice = createSlice({
  name: "getInventory",
  initialState,
  reducers: {
    fetchInventoryRequest: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchInventorySuccess: (state, action) => {
      state.loading = false;
      state.inventory = action.payload;
    },

    fetchInventoryFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchInventoryRequest,
  fetchInventorySuccess,
  fetchInventoryFailure,
} = getInventorySlice.actions;

export default getInventorySlice.reducer;